export default "__VITE_ASSET__$n1tlkc7__"